import { memo, projectFieldWithEnv } from '@morphic-ts/common/es6/utils';
import * as t from 'io-ts';
import { iotsApplyConfig } from '../config';
import { IOTSType, IoTsURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const ioTsNonStrictObjectInterpreter = memo(() => ({
    _F: IoTsURI,
    interface: (props, name, config) => (env) => {
        const types = projectFieldWithEnv(props, env)('type');
        return new IOTSType(iotsApplyConfig(config)(t.type(types, name), env, { types }));
    },
    partial: (props, name, config) => (env) => {
        const types = projectFieldWithEnv(props, env)('type');
        return new IOTSType(iotsApplyConfig(config)(t.partial(types, name), env, { types }));
    },
    both: (props, partial, name, config) => (env) => {
        const types = projectFieldWithEnv(props, env)('type');
        const partialTypes = projectFieldWithEnv(partial, env)('type');
        return new IOTSType(iotsApplyConfig(config)(t.intersection([t.interface(types), t.partial(partialTypes)], name), env, {
            types,
            partialTypes
        }));
    }
}));
/**
 *  @since 0.0.1
 */
export const ioTsStrictObjectInterpreter = memo(() => ({
    _F: IoTsURI,
    interface: (props, name, config) => (env) => {
        const types = projectFieldWithEnv(props, env)('type');
        return new IOTSType(iotsApplyConfig(config)(t.strict(types, name), env, { types }));
    },
    partial: (props, name, config) => (env) => {
        const types = projectFieldWithEnv(props, env)('type');
        return new IOTSType(iotsApplyConfig(config)(t.exact(t.partial(types, name)), env, { types }));
    },
    both: (props, partial, name, config) => (env) => {
        const types = projectFieldWithEnv(props, env)('type');
        const typesPartial = projectFieldWithEnv(partial, env)('type');
        return new IOTSType(iotsApplyConfig(config)(t.exact(t.intersection([t.interface(types), t.partial(typesPartial)], name)), env, { types, typesPartial }));
    }
}));
